import React from 'react';
import { clsx } from 'clsx';
// import { useMatomo } from '@datapunt/matomo-tracker-react'

'use strict';

function RundedrehenMapListItemClubEventPopup({item}) {
  // const { trackEvent } = useMatomo();

  let meta = [];

  if (item.time) {
    meta.push(item.time);
  }

  if (item.address) {
    meta.push(item.address);
  }

  // if (item.private) {
  //   meta.push('Nur für Clubmitglieder');
  // }

  if (item.women_only) {
    meta.push('Nur Frauen');
  }

  if (item.skill_levels) {
    const levels = {
      // '1': 'Moderat (warten auf alle)',
      '1': 'Moderat',
      '2': 'Tempo',
      '3': 'Hohes Tempo',
      '4': 'Wettkampftempo',
    }
    if (levels.hasOwnProperty(item.skill_levels)) {
      meta.push(levels[item.skill_levels]);
    }
  }

  // if (item.terrain) {
  //   const terrains = {
  //     '0': 'Flach',
  //     '1': 'Hügelig',
  //     '2': 'Bergig',
  //   }
  //   if (terrains.hasOwnProperty(item.terrain)) {
  //     meta.push(terrains[item.terrain]);
  //   }
  // }

  // if (item.distance) {
  //   meta.push(item.distance + 'km');
  // }
  // if (item.elevation_gain) {
  //   meta.push(item.elevation_gain + 'HM');
  // }

  meta = meta.join(', ');

  return <div className="
    px-2 py-2
    md:px-4 md:pt-3 md:pb-3
    bg-neutral_d rounded-md
  ">

    <div className="
      text-primary text-tiny md:text-base
      font-bold pb-2
    ">
      {item.date}
    </div>

    <div className={clsx(`
      flex
      overflow-hidden
      space-x-3 md:space-x-4
      grow`
      , {
        'items-start': meta,
        'items-center': !meta,
      }
    )}>
      <div className="
        w-10 h-10 md:w-12 md:h-12
        flex-grow-0 flex-shrink-0
        rounded overflow-hidden
        img-full
      ">
        <img
          src={item.logo_url}
          width="40" height="40"
          loading="lazy"
          alt={item.logo_alt}
          title={item.club_name}
          className="block w-100 h-auto"
        />
      </div>

      <div className="
        min-w-0
        relative
        grow
      ">
        <p className="
          font-bold
          text-white
        ">
          <a
            href={item.url}
            target="_blank"
            title="Auf Strava ansehen"
            rel="nofollow"
            className="
              block
              text-base md:text-md
              link-bigtarget
              text-white hover:text-yellow-neon
              overflow-hidden text-ellipsis
            ">
              {item.label}
            </a>
          </p>

          {meta && <p className="
            text-sm md:text-tiny tracking-wide
            text-white _dark:text-neutral_d
            nowrap overflow-hidden text-ellipsis
            mt-1 md:mt-0.5
            mb-1
          " title={meta}>
            {meta}
          </p>}

          <p className="
            text-strava font-bold text-sm
            _map-link-strava
          ">
          Auf Strava ansehen
        </p>
      </div>
    </div>
  </div>

}

export default RundedrehenMapListItemClubEventPopup;
